import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var volumePromotionSchema = {
    name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    begin_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: "yy-dd-mm",
        }),
        elementType: 'datepicker',
        label: 'Начална дата',
        value: '',
        validation: {
            required: true
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете начална дата',
    }),
    end_date: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            dateFormat: "yy-dd-mm",
        }),
        elementType: 'datepicker',
        label: 'Крайна дата',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете крайна дата',
    }),
};
export default volumePromotionSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/volumePromotionSchema.ts
// module id = 512
// module chunks = 0